import { Loader } from "./Loader";

export const PageLoader = () => (
  // a component that centers in the middle of the page
  <div className="flex justify-center items-center h-96 w-full bg-grey-100 z-50">
    <Loader />
  </div>
);
